import { Autocomplete, Box, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Stack, TextField, Typography, useTheme } from "@mui/material";
import { useNavigate } from "react-router-dom";

import Application from "../../components/application";
import MyButton from "../../components/myButton";
import MyCheckbox from "../../components/myCheckbox";
import MyInput from "../../components/myInput";
import MyLabel from "../../components/myLabel";
import MyLoading from "../../components/myLoading";
import MyPanel from "../../components/myPanel";
import useUsuarioClienteFormulario from "../../hooks/useUsuarioClienteFormulario";

const UsuarioClienteFormulario = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const states = useUsuarioClienteFormulario();
  const { formulario } = states;

  return (
    <Application>
      <MyPanel>
        <MyLoading render={states.submit} />
        <Stack spacing={2}>
          <MyLabel component="h1" text={states.editando ? "Editar Usuário Cliente" : "Cadastro de Usuário Cliente"}
            sx={{ fontSize: "15pt", fontWeight: 600, color: theme.palette.primary.main }} />

          <MyCheckbox label="Usuário ativo" checked={formulario.is_active}
            onChange={(event) => states.alterarCampo("is_active", event.target.checked)} />

          <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
            <MyInput required size="small" label="Nome" value={formulario.name}
              onChange={(event) => states.alterarCampo("name", event.target.value)}
              sx={{ flex: "2 1 300px" }} />
            <MyInput required size="small" label="Usuário Login" value={formulario.username}
              onChange={(event) => states.alterarCampo("username", event.target.value.replace(/\s/g, ""))}
              sx={{ flex: "1 1 220px" }} />
          </Box>

          <MyInput required size="small" type="email" label="E-mail" value={formulario.email}
            onChange={(event) => states.alterarCampo("email", event.target.value)} />

          <Autocomplete multiple size="small" options={states.postos} value={formulario.postos}
            getOptionLabel={(option) => option.nome}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            onChange={(_, value) => states.alterarCampo("postos", value)}
            renderInput={(params) => <TextField {...params} required label="Postos" />} />

          <Autocomplete multiple size="small" options={states.tiposTarefa} value={formulario.tipos_tarefa}
            getOptionLabel={(option) => option.nome}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            onChange={(_, value) => states.alterarCampo("tipos_tarefa", value)}
            renderInput={(params) => <TextField {...params} required label="Tipos de tarefa" />} />

          <MyLabel component="p" text={states.editando ? "A senha atual será mantida." : "A senha será gerada automaticamente pelo sistema."}
            sx={{ fontSize: "0.85rem", color: "text.secondary" }} />

          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <MyButton color="warning" variant="contained" text="Voltar"
              onClick={() => navigate("/gestor/usuarios-clientes")} />
            <MyButton color="success" variant="contained" text="Salvar"
              disabled={states.submit} onClick={states.salvar} />
          </Box>
        </Stack>
      </MyPanel>
      <Dialog open={Boolean(states.senhaProvisoria)} disableEscapeKeyDown>
        <DialogTitle>Usuário cliente cadastrado</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Informe esta senha provisória ao usuário. Ela será exibida somente agora.
          </DialogContentText>
          <Typography variant="h5" sx={{ mt: 2, fontWeight: 700, textAlign: "center" }}>
            {states.senhaProvisoria}
          </Typography>
        </DialogContent>
        <DialogActions>
          <MyButton color="success" variant="contained" text="Entendi"
            onClick={() => navigate("/gestor/usuarios-clientes")} />
        </DialogActions>
      </Dialog>
    </Application>
  );
};

export default UsuarioClienteFormulario;
